import { notification } from 'antd';

import { UserRole } from '../../../enum';
import { isValidPhoneNumber, PHONE_NUMBER_VALIDATION_MESSAGE } from '../../../helpers/phoneNumber.helper';
import type { AdminClinician } from './adminClinicianSlice';

export const validateAdminClinician = (adminClinician: AdminClinician) => {
  if (
    !adminClinician.first_name ||
    !adminClinician.last_name ||
    !adminClinician.role ||
    !adminClinician.email ||
    !adminClinician.job_id ||
    (adminClinician.role !== UserRole.ORGANIZATION && (!adminClinician.site_ids || adminClinician.site_ids.length < 1))
  ) {
    notification.error({
      title: 'Missing required fields',
      description: 'Please provide values for all required fields.',
    });
    return false;
  } else if (!adminClinician.email.match(/^[^@]+@[^@]+\.\w\w+$/g)) {
    notification.error({
      title: 'Invalid email',
      description: 'Please provide a valid email.',
    });
    return false;
  } else if (adminClinician.mobile_phone && !isValidPhoneNumber(adminClinician.mobile_phone)) {
    notification.error({
      title: 'Invalid mobile phone number',
      description: PHONE_NUMBER_VALIDATION_MESSAGE,
    });
    return false;
  } else {
    return true;
  }
};
